import {computed, defineComponent, onMounted, toRefs, watch} from 'vue';
import {useUserStore} from "@/app/stores/user-store.ts";
import {type IAlertNotification, useErrorStore} from "@/app/stores/error-store.ts";
import {useGlobalHeaderStore} from "@/app/stores/global-header-store.ts";
import {useRouter} from "vue-router";
import AegLoader from '@/app/shared/components/aeg-loader/aeg-loader.vue';
import {Toast} from 'primevue';

export default defineComponent({
    name: 'app',
    components: {AegLoader, Toast},
    props: {},
    setup() {
        const userStore = useUserStore();
        const errorStore = useErrorStore();
        const globalHeaderStore = useGlobalHeaderStore();
        const {isAuthenticated, isCheckingAuthentication, isLoading, isAdmin} = toRefs(userStore)

        const {alerts} = toRefs(errorStore);
        const router = useRouter();
        const handleAutoCloseAlerts = (newAlerts: IAlertNotification[], oldAlerts: IAlertNotification[]) => {
            const getAutoCloseAlerts = (alerts: IAlertNotification[]) => alerts.filter(alert => alert.autoClose);

            const newAutoCloseAlerts = getAutoCloseAlerts(newAlerts);
            const oldAutoCloseAlerts = getAutoCloseAlerts(oldAlerts);

            const haveAlertsChanged = JSON.stringify(newAutoCloseAlerts) !== JSON.stringify(oldAutoCloseAlerts);

            if (haveAlertsChanged && newAutoCloseAlerts.length > 0) {
                newAutoCloseAlerts.forEach(alert => {
                    setTimeout(() => {
                        errorStore.removeAlert(alert.id);
                    }, alert.autoClose);
                });
            }
        };


        const showAdminNavigation = computed((): boolean => {
            return isAdmin.value;
        });

        const allowAnonymous = computed(() => {
            return router.currentRoute.value.meta?.allowAnonymous ?? false;
        });

        const isLoadingUserData = computed(() => {
            return isCheckingAuthentication.value || isLoading.value;
        });

        const closeAlert = (alertId: string): void => {
            errorStore.removeAlert(alertId);
        };

        watch(alerts, handleAutoCloseAlerts, {
            deep: true,
            immediate: false
        });

        onMounted(async () => {
            const headerMountElement = document.getElementsByClassName('global-header')[0] as HTMLElement;
            const footerMountElement = document.getElementsByClassName('global-footer')[0] as HTMLElement;
            if (!globalHeaderStore.isMounted) {
                await globalHeaderStore.setup(headerMountElement, footerMountElement);
            }
        });

        return {
            alerts,
            isAuthenticated,
            allowAnonymous,
            isLoadingUserData,
            showAdminNavigation,
            closeAlert
        }
    }
})
